import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import * as api from 'helpers/api';
import { Modal, ProgressBar } from 'react-bootstrap';

export class DuplicationForm extends React.Component {
  static propTypes = {
    assignment: PropTypes.bool,
    features: PropTypes.shape({
      projectAttachments: PropTypes.bool
    }).isRequired,
    projectId: PropTypes.number.isRequired,
    projectTitle: PropTypes.string.isRequired,
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired
  }

  state = {
    attachments: this.props.features.projectAttachments,
    docs: true,
    duplicating: false,
    duplicationId: null,
    duplicationStatus: null,
    newPropertyUrl: null,
    photos: true,
    proposal: false,
    percentComplete: 0,
    statusUrl: null
  }

  pollDuplicationStatus = () => {
    api.get(this.state.statusUrl).then((data) => {
      this.setState({
        percentComplete: data.percentComplete,
        duplicationStatus: data.status
      });

      if (data.percentComplete >= 100) {
        window.location = data.url;
        return;
      }

      setTimeout(this.pollDuplicationStatus, 1000);
    });
  }

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.checked });
  }

  handleSubmit = () => {
    this.setState({ duplicating: true, duplicationStatus: "Preparing to duplicate" });
    const data = {
      propertyDuplication: {
        existingPropertyId: this.props.projectId,
        duplicateAttachments: this.state.attachments,
        duplicatePhotos: this.state.photos,
        duplicateDocs: this.state.docs,
        forceProposal: this.state.proposal
      }
    };
    api.post("/property_duplications", data).then((response) => {
      this.setState({ duplicationId: response.id, statusUrl: response.statusUrl });
      this.pollDuplicationStatus();
    });
  }

  renderCheckbox(label, key) {
    return (
      <div className="form-group boolean optional">
        <div className="checkbox">
          <label className="boolean optional">
            <input
              checked={this.state[key]}
              className="boolean optional"
              name={key}
              type="checkbox"
              onChange={this.handleInputChange}
            />
            {label}
          </label>
        </div>
      </div>
    );
  }

  renderStatus() {
    return (
      <div>
        <h4>{this.state.duplicationStatus}</h4>
        <ProgressBar active now={this.state.percentComplete} />
      </div>
    );
  }

  renderModalBody() {
    if (this.state.duplicating) {
      return this.renderStatus();
    }
    return (
      <React.Fragment>
        {this.props.assignment ? (
          <div className="bottom-buffer-sm">
            {this.renderCheckbox("Duplicate Attachments", "attachments")}
            <hr/>
            Client Details and Requirements will be duplicated.
            <hr/>
          </div>
        ) : (
          <div>
            {this.renderCheckbox("Duplicate Photos", "photos")}
            {this.renderCheckbox("Duplicate Docs", "docs")}
            {this.props.features.projectAttachments && this.renderCheckbox('Duplicate Attachments', 'attachments')}
            <hr/>
            {this.renderCheckbox("Create as a proposal?", "proposal")}
            <hr/>
          </div>
        )}
        <input
          className="btn btn-primary"
          name="submit"
          type="submit"
          value={this.props.assignment ? "Duplicate Assignment" : "Duplicate Property"}
          onClick={this.handleSubmit}
        />
      </React.Fragment>
    );
  }

  render() {
    return (
      <Modal show={this.props.show} onHide={this.props.onHide}>
        <Modal.Header closeButton>
          <h4>
            Duplicate '{this.props.projectTitle}'?
          </h4>
        </Modal.Header>
        <Modal.Body>
          {this.renderModalBody()}
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  features: state.features
});

export default connect(mapStateToProps)(DuplicationForm);
